import { render, staticRenderFns } from "./SearchImageAutomatica.vue?vue&type=template&id=1237571c&"
import script from "./SearchImageAutomatica.vue?vue&type=script&lang=js&"
export * from "./SearchImageAutomatica.vue?vue&type=script&lang=js&"
import style0 from "./SearchImageAutomatica.vue?vue&type=style&index=0&id=1237571c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports